import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');

const ProjectActions = require('../../actions/ProjectActions');
const ProjectStore = require('../../stores/ProjectStore');
const PermissionsUtil = require('../../../../app/shared/PermissionsUtil');
const Strings = require('../../../../app/shared/Strings');

const propTypes = {
    inputId: PropTypes.string,
    className: PropTypes.string,
    projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    channelUserPermissions: PropTypes.object,
    projectUserPermissions: PropTypes.object
};

const defaultProps = {
    inputId: 'proj-description',
    className: '',
    channelUserPermissions: {},
    projectUserPermissions: {}
};

class ProjectDescriptionEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            projectStoreState: ProjectStore.getStateProject(props.projectId),
            description: '',
            descriptionClean: true,
            descriptionUpdateActionId: null
        };

        this.setDescription = this.setDescription.bind(this);
        this.updateDescription = this.updateDescription.bind(this);

        this.unsubscribes = [ProjectStore.listen(this.onProjectStoreStateChange.bind(this))];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(unsubscribeCallback => { unsubscribeCallback(); });
    }

    onProjectStoreStateChange(newState) {
        let updatedState = { projectStoreState: ProjectStore.getStateProject(this.props.projectId) };

        if (newState.action.id === this.state.descriptionUpdateActionId) {
            updatedState = { ...updatedState, descriptionClean: true, descriptionUpdateActionId: null };
        }

        this.setState(updatedState);
    }

    setDescription(e) {
        this.setState({ description: e.target.value, descriptionClean: false });
    }

    updateDescription() {
        const actionId = uuid.v4();
        this.setState({ descriptionUpdateActionId: actionId }, () => {
            ProjectActions.updateProjectDescription(actionId, {
                projectID: this.props.projectId,
                description: this.state.description,
            });
        });
    }

    render() {
        const project = this.state.projectStoreState.project || this.state.projectStoreState.shortCourseProject || null;
        if (!project) {
            return null;
        }

        const projectDescription = this.state.descriptionClean ? project.description : this.state.description;
        const canEditProjectDescription = PermissionsUtil.canEditProjectDescription(this.props.channelUserPermissions, this.props.projectUserPermissions);

        return (
            <div className={this.props.className}>
                <textarea
                    id={this.props.inputId}
                    className="projectDescInput margin-bottom-md"
                    value={projectDescription}
                    placeholder={Strings['en'].project.PROJ_DESC_PROMPT}
                    rows='4'
                    disabled={!canEditProjectDescription}
                    onChange={this.setDescription}
                />
                {(canEditProjectDescription) &&
                    <button
                        className="btn btn-primary block"
                        onClick={this.updateDescription}
                        disabled={this.state.descriptionClean || !!this.state.descriptionUpdateActionId}
                    >
                        {Strings['en'].common.UPDATE}
                    </button>
                }
            </div>
        );
    }
}

ProjectDescriptionEditor.propTypes = propTypes;
ProjectDescriptionEditor.defaultProps = defaultProps;

export default ProjectDescriptionEditor;